/* ==================================================================
   Warenkorb-Flyout (Rebuy-Ersatz)
   Section: sections/epi-cart-drawer.liquid · CSS: assets/epi-cart.css

   Öffnet nach jedem Add-to-Cart des Themes (Event theme:cart:popdown)
   und beim Klick auf das Warenkorb-Icon. Der Inhalt wird nach jeder
   Änderung serverseitig neu gerendert (Section-Rendering-API), damit
   Balken, Geschenke und Cross-Sell immer der Liquid-Logik folgen.
   ================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-epi-cart]');
  if (!root) return;

  var panel, errors;
  var sectionId = root.getAttribute('data-section-id');
  var routes = (window.theme && window.theme.routes) || {};
  var rootUrl = (routes.root_url || '/').replace(/\/?$/, '/');
  var cartUrl = (routes.cart || '/cart').replace(/\/$/, '');

  var isOpen = false;
  var busy = false;
  var internalChange = false;
  var shipCache = {};
  var timers = {};
  var errorTimer = null;
  var lastFocus = null;
  var viewed = {};
  var GENERIC_ERROR = 'Der Warenkorb konnte nicht aktualisiert werden. Bitte Seite neu laden.';
  var TIMEOUT_ERROR = 'Die Verbindung ist gerade langsam – bitte erneut versuchen.';
  var FETCH_TIMEOUT = 15000;   /* Cart-API + Section-Rendering: nach 15 s abbrechen statt ewig zu dimmen (Mobilfunk) */
  var QTY_DEBOUNCE = 300;      /* Stepper: mehrere Tipps sammeln, ein change.js mit der Endmenge */

  /* Tracking: GTM-dataLayer (Klicks/Sichtungen) – Bestellungen werden über die
     versteckte Positions-Eigenschaft _epi_cart + Shopify-Flow-Order-Tags gezählt */
  var analyticsUrl = (root.getAttribute('data-analytics') || '').replace(/\/$/, '');
  function sessionId() {
    var id = null;
    try { id = sessionStorage.getItem('epiCartSession'); } catch (e) {}
    if (!id) {
      id = Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
      try { sessionStorage.setItem('epiCartSession', id); } catch (e) {}
    }
    return id;
  }
  function track(action, label, value) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'epi_cart', epi_cart_action: action, epi_cart_label: label || '', epi_cart_value: value || 0 });
    } catch (e) {}
    if (!analyticsUrl) { return; }
    try {
      var payload = JSON.stringify({
        action: action, label: (label || '').slice(0, 160), value: value || 0, session: sessionId(),
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
        path: window.location.pathname.slice(0, 200), mobile: window.innerWidth <= 768
      });
      /* text/plain + credentials:omit = kein CORS-Preflight; der Server parst den Body als JSON */
      fetch(analyticsUrl + '/events', { method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: { 'Content-Type': 'text/plain' }, body: payload }).catch(function () {});
    } catch (e) {}
  }
  function trackViews() {
    var state = panel.querySelector('[data-epi-cart-state]');
    var total = state ? parseInt(state.getAttribute('data-total'), 10) : 0;
    /* Sichtungen je Produkt (einmal je Öffnen und Produkt), damit die Analytics-App
       „gesehen, aber nicht geklickt“ auswerten kann */
    var checks = [
      ['upgrade_view', '[data-epi-upgrade]'],
      ['geschenk_view', '[data-epi-add][data-source="geschenk"]'],
      ['cross-sell_view', '[data-epi-add][data-source="cross-sell"]']
    ];
    checks.forEach(function (c) {
      var els = panel.querySelectorAll(c[1]);
      for (var i = 0; i < els.length; i++) {
        var label = els[i].getAttribute('data-label') || '';
        var key = c[0] + '|' + label;
        if (!viewed[key]) { viewed[key] = true; track(c[0], label, total); }
      }
    });
  }

  /* ---------- Helfer ---------------------------------------------- */
  /* Antworten der Cart-API robust lesen: Shopify liefert bei 429/5xx auch HTML oder leere
     Bodies – dann kein SyntaxError an den Kunden durchreichen, sondern ein Fehlerobjekt mit
     verständlicher description werfen. */
  /* fetch mit Abbruch nach `ms` (Header UND Body): auf langsamem Mobilfunk bleibt das Flyout sonst
     minutenlang gedimmt. Liefert { res, text }; ein Abbruch wird als Fehler mit description gemeldet. */
  function fetchWithTimeout(url, opts, ms) {
    opts = opts || {};
    var ctrl = null, timer = null;
    if (typeof AbortController === 'function') {
      ctrl = new AbortController();
      opts.signal = ctrl.signal;
      timer = setTimeout(function () { ctrl.abort(); }, ms || FETCH_TIMEOUT);
    }
    return fetch(url, opts)
      .then(function (r) { return r.text().then(function (text) { return { res: r, text: text }; }); })
      .then(function (out) { clearTimeout(timer); return out; }, function (e) {
        clearTimeout(timer);
        if (e && e.name === 'AbortError') { throw { description: TIMEOUT_ERROR, timeout: true }; }
        throw e;
      });
  }
  function fetchJSON(url, opts) {
    return fetchWithTimeout(url, opts, FETCH_TIMEOUT).then(function (out) {
      var r = out.res, text = out.text;
      var json = null;
      if (text) { try { json = JSON.parse(text); } catch (e) { json = null; } }
      if (!r.ok) {
        var err = (json && typeof json === 'object') ? json : {};
        if (typeof err.description !== 'string') {
          err.description = r.status === 429
            ? 'Zu viele Anfragen – bitte einen Moment warten und erneut versuchen.'
            : GENERIC_ERROR;
        }
        err.status = r.status;
        throw err;
      }
      return json === null ? {} : json;
    });
  }
  function post(url, body) {
    return fetchJSON(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function looksLikeCart(c) { return !!(c && typeof c === 'object' && typeof c.item_count === 'number' && c.items); }
  function dispatchChange(cart) {
    internalChange = true;
    try { document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true })); }
    finally { internalChange = false; }
  }
  /* Theme (Header-Zähler) über die Änderung informieren. Fällt /cart.js aus, reicht die
     Antwort von change.js (= kompletter Warenkorb) als Ersatz. */
  function fireChange(result) {
    return fetchJSON(cartUrl + '.js', { credentials: 'same-origin' })
      .catch(function (e) { if (looksLikeCart(result)) { return result; } throw e; })
      .then(function (cart) { dispatchChange(cart); return cart; });
  }
  var errorCount = 0;
  function showError(err) {
    errorCount++;
    var msg = (err && typeof err.description === 'string' && err.description) || GENERIC_ERROR;
    errors.textContent = msg;
    errors.hidden = false;
    clearTimeout(errorTimer);
    errorTimer = setTimeout(function () { errors.hidden = true; }, 6000);
  }
  /* Screenreader-Status („Menge geändert“) – der Re-Render tauscht den ganzen Panel-Inhalt, ersetzte
     aria-live-Knoten werden nicht vorgelesen. Braucht ein <span data-epi-status aria-live="polite">
     außerhalb von [data-epi-cart-panel]; fehlt es, passiert nichts. */
  var status = null;
  function announce(msg) {
    if (!status) { return; }
    status.textContent = '';
    setTimeout(function () { status.textContent = msg; }, 50);
  }

  /* ---------- Rendern --------------------------------------------- */
  var refreshSeq = 0;
  var inflight = null;
  var pendingFocus = null;
  /* Fokus über einen Re-Render retten: Selektor + Index, weil z. B. „−“ und „+“ einer Zeile
     denselben data-key tragen und mehrere Zeilen dasselbe Produkt enthalten können. */
  function focusSelector(el) {
    if (!el || !panel.contains(el)) { return null; }
    var attrs = ['data-epi-close', 'data-epi-qty', 'data-epi-remove', 'data-epi-upgrade', 'data-epi-add'];
    for (var i = 0; i < attrs.length; i++) {
      if (el.hasAttribute(attrs[i])) {
        var key = el.getAttribute('data-key') || el.getAttribute('data-epi-remove') || el.getAttribute('data-epi-upgrade') || el.getAttribute('data-epi-add') || '';
        var sel = '[' + attrs[i] + ']' + (key ? '[data-key="' + key + '"],[' + attrs[i] + '="' + key + '"]' : '');
        var all = panel.querySelectorAll(sel);
        var idx = Array.prototype.indexOf.call(all, el);
        return { sel: sel, idx: idx < 0 ? 0 : idx };
      }
    }
    return null;
  }
  function restoreFocus(restore) {
    if (!isOpen) { return; }
    var target = null;
    if (restore) {
      var all = panel.querySelectorAll(restore.sel);
      target = all[restore.idx] || all[all.length - 1] || null;
    }
    /* Ziel weg (Zeile entfernt) oder Fokus lag auf einem ersetzten Element → Close-Button,
       damit die Tastatur nicht auf <body> hinter dem Dialog landet */
    if (!target && (!document.activeElement || !panel.contains(document.activeElement))) {
      target = panel.querySelector('[data-epi-close]');
    }
    if (target) { try { target.focus({ preventScroll: true }); } catch (e) {} }
  }
  function refresh() {
    var seq = ++refreshSeq;
    var url = rootUrl + '?section_id=' + encodeURIComponent(sectionId);
    var restore = pendingFocus || focusSelector(document.activeElement);
    pendingFocus = null;
    var p = fetchWithTimeout(url, { credentials: 'same-origin' }, FETCH_TIMEOUT)
      .then(function (out) { if (!out.res.ok) { throw new Error('HTTP ' + out.res.status); } return out.text; })
      .then(function (html) {
        if (seq !== refreshSeq) { return; }  /* ein neuerer Render ist unterwegs */
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-epi-cart-panel]');
        if (!fresh) { throw new Error('Section nicht gefunden'); }
        clearTimers();
        panel.innerHTML = fresh.innerHTML;
        afterRender();
        restoreFocus(restore);
      })
      .catch(function (e) {
        if (seq !== refreshSeq) { return; }
        console.warn('epi-cart: Rendern fehlgeschlagen', e);
        /* alter Inhalt bleibt stehen – deaktivierte Aktions-Buttons wieder freigeben */
        Array.prototype.forEach.call(panel.querySelectorAll('button[disabled]'), function (b) { b.disabled = false; });
        showError({ description: (e && e.timeout) ? TIMEOUT_ERROR : 'Der Warenkorb konnte nicht geladen werden. Bitte Seite neu laden.' });
      })
      .then(function () { if (inflight === p) { inflight = null; } });
    inflight = p;
    return p;
  }

  var giftTries = {};
  function afterRender() {
    var state = panel.querySelector('[data-epi-cart-state]');
    var keys = state ? (state.getAttribute('data-gift-keys') || '') : '';
    if (state && state.getAttribute('data-remove-gifts') === 'true' && !busy) {
      giftTries[keys] = (giftTries[keys] || 0) + 1;
      if (giftTries[keys] <= 2) {  /* höchstens zwei Versuche je Schlüsselsatz, sonst Endlosschleife bei Fehlern */
        removeGifts(keys);
        return;
      }
    } else if (state) {
      giftTries = {};
    }
    syncPromo(state);
    eagerImages();
    markScrollable();
    applyPending();
    updateDelivery();
    updateShipping(state);
    initTimers();
    markSliders();
    trackViews();
  }
  /* Scroll-Lock des Themes (scroll-lock-Bibliothek, s. open()): auf iOS blockt sie jedes touchmove,
     das nicht in einem als scrollbar markierten Element liegt. Das Markup wird bei jedem Render
     ersetzt, daher die Markierung hier statt einmalig. */
  function markScrollable() {
    Array.prototype.forEach.call(panel.querySelectorAll('.epi-cart__scroll, .epi-cart__cards'), function (el) {
      el.setAttribute('data-scroll-lock-scrollable', '');
    });
  }
  /* Das Section-Markup setzt loading="lazy"; im Flyout stehen die ersten Bilder aber sofort im
     sichtbaren Bereich – Safari lädt lazy-Bilder erst spät (kleiner Schwellwert, Panel ist beim
     Einblenden noch außerhalb des Viewports). Die ersten vier werden deshalb direkt geladen. */
  function eagerImages() {
    var imgs = panel.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length && i < 4; i++) { imgs[i].setAttribute('loading', 'eager'); }
  }

  /* Aktions-Geschenk per Rabattcode: Liquid kennt die Rabattcodes des Warenkorbs nicht, /cart.js
     schon (discount_codes, auch über den Link /discount/CODE gesetzt). Steckt der Code der Section
     drin, wird er ins versteckte Attribut _epi_promo übernommen und aus dem Warenkorb genommen
     (andere Codes bleiben): Der Code ist nur die Eintrittskarte. Im Checkout würde ein
     Versandkostenfrei-Code sonst „für deine Lieferadresse nicht verfügbar“ melden, sobald der Versand
     ohnehin gratis ist (Maria 22.10.2026). Das Attribut bleibt danach stehen; geleert wird es erst,
     wenn in der Section kein bzw. ein anderer Code eingetragen ist. Ohne Code in den
     Section-Einstellungen passiert hier nichts (kein zusätzlicher Request). */
  /* Shopify merkt sich den Link-Code zusätzlich im Cookie discount_code und hängt ihn im Checkout
     wieder an, auch wenn er aus dem Warenkorb genommen wurde (Test 22.10.2026, CH-Abo) – deshalb wird
     das Cookie nach der Übernahme gelöscht. */
  function promoCookieHas(code) {
    var c = '';
    try { c = decodeURIComponent(document.cookie || '').toUpperCase(); } catch (e) {}
    return !!code && /(^|;\s*)DISCOUNT_CODE=/.test(c) && c.indexOf(code) > -1;
  }
  function clearPromoCookie() {
    var host = window.location.hostname.replace(/^www\./, '');
    ['', '; domain=' + host, '; domain=.' + host].forEach(function (d) {
      document.cookie = 'discount_code=; Max-Age=0; path=/' + d;
    });
  }
  var promoChecked = '';
  var promoTries = 0;
  function syncPromo(state) {
    var code = state ? (state.getAttribute('data-promo-code') || '') : '';
    var attr = state ? (state.getAttribute('data-promo-attr') || '') : '';
    if (!code && !attr) { return; }
    var inCookie = promoCookieHas(code);
    if (busy || (!inCookie && promoChecked === code + '|' + attr)) { return; }
    promoChecked = code + '|' + attr;
    fetchJSON(cartUrl + '.js', { credentials: 'same-origin' }).then(function (cart) {
      var codes = ((cart && cart.discount_codes) || []).map(function (d) { return String((d && d.code) || ''); });
      var isPromo = function (c) { return !!code && c.toUpperCase() === code; };
      var body = null;
      if (codes.some(isPromo) || (inCookie && attr !== code)) {
        body = { attributes: { _epi_promo: code }, discount: codes.filter(function (c) { return !isPromo(c); }).join(',') };
      } else if (attr && attr !== code) {
        body = { attributes: { _epi_promo: '' } };
      }
      if (!body) {
        if (inCookie) { clearPromoCookie(); }  /* schon übernommen, nur das Cookie ist noch da */
        return;
      }
      if (++promoTries > 3) { return; }  /* keine Endlosschleife bei Fehlern */
      enqueue(function () {
        return post(cartUrl + '/update.js', body).then(function (res) {
          if (body.attributes._epi_promo) { clearPromoCookie(); }
          return res;
        });
      }, '');
    }).catch(function () {});
  }
  /* Beim Seitenaufruf nach dem Kampagnen-Link sofort übernehmen – auch wer ohne Flyout direkt zur
     Kasse geht, soll den Code dort nicht sehen. Nur wenn das Shopify-Cookie den Code trägt. */
  (function () {
    var st = root.querySelector('[data-epi-cart-state]');
    var code = st ? (st.getAttribute('data-promo-code') || '') : '';
    if (promoCookieHas(code)) {
      setTimeout(function () { syncPromo(st); }, 0);
    }
  })();

  /* Geschenke automatisch entfernen, sobald der Warenkorb unter die Stufe fällt */
  function removeGifts(keys) {
    var list = (keys || '').split(',').filter(Boolean);
    if (!list.length) { return; }
    list.forEach(function (key) {
      enqueue(function () { return post(cartUrl + '/change.js', { id: key, quantity: 0 }); }, '');
    });
  }

  /* ---------- Warteschlange für Cart-Aufrufe ------------------------ */
  /* Alle Änderungen laufen nacheinander (Shopify verträgt keine parallelen Cart-Calls), ein
     Re-Render erst, wenn die Schlange leer ist. Solange etwas läuft, ist busy gesetzt und das
     Panel gedimmt (CSS is-loading). */
  var queue = [];
  var running = false;
  var lastNote = '';
  function enqueue(job, note) {
    queue.push({ job: job, note: note || '' });
    if (!running) { runQueue(); }
  }
  function runQueue() {
    if (!queue.length) {
      running = false;
      busy = false;  /* vor refresh(): afterRender darf Geschenke nur bei freiem Zustand abräumen */
      return refresh().then(function () {
        /* Ladezustand erst nach dem Re-Render lösen – bis dahin steht noch der alte DOM
           (Klicks darauf würden auf veraltete Mengen/Buttons gehen) */
        if (!busy) { root.classList.remove('is-loading'); }
        if (lastNote) { announce(lastNote); lastNote = ''; }
      });
    }
    running = true;
    busy = true;
    root.classList.add('is-loading');
    var item = queue.shift();
    return Promise.resolve().then(item.job).then(fireChange).then(function () { lastNote = item.note; })
      .catch(function (e) { lastNote = ''; showError(e); })
      .then(runQueue);
  }
  function hasPending() { return Object.keys(pending).length > 0; }
  function whenIdle() {
    return new Promise(function (res) {
      (function poll() {
        if (!busy && !inflight && !hasPending()) { res(); } else { setTimeout(poll, 50); }
      })();
    });
  }

  /* ---------- Stepper: optimistisch + gebündelt ----------------------- */
  /* Mobil tippen Kund:innen „+“ gern zweimal schnell hintereinander. Statt den zweiten Tipp zu
     verwerfen (busy), zeigt die Zahl sofort den neuen Wert; nach 300 ms Ruhe geht EIN change.js
     mit der Endmenge raus. Die Button-Attribute bleiben unverändert, die Richtung ergibt sich aus
     Button-Ziel minus gerenderter Menge. */
  var pending = {};
  var pendingTimers = {};
  function stepQty(t) {
    var key = t.getAttribute('data-key');
    var target = parseInt(t.getAttribute('data-epi-qty'), 10);
    if (!key || isNaN(target)) { return; }
    var stepper = t.closest('.epi-cart__stepper');
    var val = stepper ? stepper.querySelector('.epi-cart__stepper-value') : null;
    var p = pending[key];
    /* base = Menge laut letztem Server-Render; die Buttons tragen base−1 / base+1, die Anzeige
       zeigt aber schon die optimistische Menge – die Richtung kommt deshalb aus target − base */
    var base = p ? p.base : (val ? parseInt(val.textContent, 10) : NaN);
    var qty = p ? p.qty + (target - base) : target;
    if (isNaN(qty)) { qty = target; }
    if (qty < 0) { qty = 0; }
    pending[key] = { qty: qty, base: base, el: t };
    if (val) { val.textContent = String(qty); }
    clearTimeout(pendingTimers[key]);
    if (qty <= 0) { flushKey(key); return; }  /* „−“ bei 1 = Zeile entfernen, sofort */
    pendingTimers[key] = setTimeout(function () { flushKey(key); }, QTY_DEBOUNCE);
  }
  function flushKey(key) {
    var p = pending[key];
    clearTimeout(pendingTimers[key]);
    delete pendingTimers[key];
    delete pending[key];
    if (!p) { return; }
    if (p.qty === p.base) { return; }  /* „+“ und „−“ heben sich auf – nichts zu senden */
    pendingFocus = focusSelector(p.el) || pendingFocus;
    enqueue(function () { return post(cartUrl + '/change.js', { id: key, quantity: p.qty }); },
      p.qty > 0 ? 'Menge auf ' + p.qty + ' geändert' : 'Artikel entfernt');
  }
  function flushPending() { Object.keys(pending).forEach(flushKey); }
  /* nach einem Re-Render (z. B. fremdes theme:cart:change) die noch nicht gesendete Menge weiter anzeigen */
  function applyPending() {
    Object.keys(pending).forEach(function (key) {
      var btn = panel.querySelector('[data-epi-qty][data-key="' + key + '"]');
      var stepper = btn ? btn.closest('.epi-cart__stepper') : null;
      var val = stepper ? stepper.querySelector('.epi-cart__stepper-value') : null;
      if (!val) { return; }
      var rendered = parseInt(val.textContent, 10);
      if (!isNaN(rendered)) { pending[key].base = rendered; }  /* Buttons beziehen sich jetzt auf den neuen Server-Stand */
      val.textContent = String(pending[key].qty);
    });
  }
  /* Seite verlassen, bevor die 300 ms um sind: Menge trotzdem noch schicken (keepalive) */
  window.addEventListener('pagehide', function () {
    Object.keys(pending).forEach(function (key) {
      var p = pending[key];
      clearTimeout(pendingTimers[key]);
      delete pending[key];
      try {
        fetch(cartUrl + '/change.js', { method: 'POST', credentials: 'same-origin', keepalive: true,
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: p.qty }) }).catch(function () {});
      } catch (e) {}
    });
  });

  /* ---------- Öffnen / Schließen --------------------------------- */
  function open() {
    if (isOpen) {
      /* Header-Klick während einer laufenden Aktion: die Aktion rendert gleich selbst */
      if (!busy) { refresh(); }
      return;
    }
    isOpen = true;
    viewed = {};
    lastFocus = document.activeElement;
    track('open');
    root.classList.add('is-visible');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('epi-cart-open');
    setScrollLock(true);
    refresh().then(function () {
      if (!isOpen) { return; }
      if (document.activeElement && panel.contains(document.activeElement) && document.activeElement !== document.body) { return; }
      var closeBtn = panel.querySelector('[data-epi-close]');
      if (closeBtn) { closeBtn.focus({ preventScroll: true }); }
    });
  }
  function close() {
    if (!isOpen) { return; }
    isOpen = false;
    root.classList.remove('is-visible');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('epi-cart-open');
    setScrollLock(false);
    clearTimers();  /* Countdown tickt nicht im Hintergrund weiter – open() rendert neu und startet ihn wieder */
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    else if (document.activeElement && root.contains(document.activeElement)) { try { document.activeElement.blur(); } catch (e) {} }
  }

  /* Hintergrund-Scroll sperren wie die Theme-Drawer: das Theme hört auf theme:scroll:lock/unlock
     (scroll-lock-Bibliothek in vendor.js). Die setzt body{overflow:hidden} plus Scrollbar-Ausgleich
     und blockt auf iOS touchmove außerhalb von [data-scroll-lock-scrollable] – html{overflow:hidden}
     allein reicht dort nicht (Seite schiebt sich beim Wischen über Kopf/Fuß/Underlay mit).
     Das Theme sperrt selbst erst im nächsten Tick, darum auch das Entsperren verzögert, sonst
     könnte bei open()+close() im selben Tick die Sperre hängen bleiben. */
  var lockTimer = null;
  function setScrollLock(on) {
    clearTimeout(lockTimer);
    lockTimer = setTimeout(function () {
      lockTimer = null;
      if (on !== isOpen) { return; }
      if (on) {
        markScrollable();
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: panel.querySelector('.epi-cart__scroll') }));
      } else {
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      }
    }, 0);
  }

  /* ---------- DHL-Lieferzeile (wie bisheriger Rebuy-Callback) ----- */
  function isDE() {
    var tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    return tz.indexOf('Berlin') > -1;
  }
  function addBiz(d, n) {
    var r = new Date(d), a = 0;
    while (a < n) { r.setDate(r.getDate() + 1); if (r.getDay() % 6) { a++; } }
    return r;
  }
  function fmt(d) {
    var days = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    return days[d.getDay()] + ' ' + d.getDate() + '.' + (d.getMonth() + 1) + '.';
  }
  function updateDelivery() {
    var el = panel.querySelector('[data-epi-delivery]');
    if (!el) { return; }
    var now = new Date();
    var cutoff = parseInt(root.getAttribute('data-cutoff'), 10) || 13;
    var biz = isDE() ? (now.getHours() < cutoff ? 1 : 2) : 5;
    var from = addBiz(now, biz), to = addBiz(from, 1);
    el.textContent = (el.getAttribute('data-prefix') || '') + ' ' + fmt(from) + ' – ' + fmt(to);
  }
  function updateShipping(state) {
    var el = panel.querySelector('[data-epi-shipping-cost]');
    if (!el) { return; }
    var row = el.closest('[data-epi-delivery-row]');
    var de = isDE();
    var query = 'shipping_address[zip]=' + (de ? '10115' : '8001') + '&shipping_address[country]=' + (de ? 'DE' : 'CH');
    var key = query + '|' + (state ? state.getAttribute('data-total') + '|' + state.getAttribute('data-count') : '');
    var apply = function (price) {
      if (price === 0) {
        el.textContent = el.getAttribute('data-free') || 'Kostenlos';
        if (row) { row.classList.remove('is-paid'); }
      } else {
        var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
        /* geschütztes Leerzeichen wie bei Rebuy: „2,99 €“ bricht nie zwischen Betrag und Symbol um */
        el.textContent = price.toFixed(2).replace('.', ',') + '\u00a0' + (cur === 'CHF' ? 'CHF' : '€');
        if (row) { row.classList.add('is-paid'); }
      }
    };
    if (shipCache[key] !== undefined) { apply(shipCache[key]); return; }
    var attempt = 0;
    var ask = function () {
      return fetchWithTimeout(cartUrl + '/shipping_rates.json?' + query, { credentials: 'same-origin' }, 10000).then(function (out) {
        var r = out.res;
        if (r.status === 202 && attempt < 2) {  /* Shopify berechnet noch – kurz warten, erneut fragen */
          attempt++;
          return new Promise(function (res) { setTimeout(res, 1200); }).then(ask);
        }
        if (!r.ok) { throw new Error('HTTP ' + r.status); }  /* Fehlerantwort nie als „Kostenlos“ deuten */
        return JSON.parse(out.text);
      });
    };
    ask()
      .then(function (data) {
        var rates = (data && data.shipping_rates) || [];
        var price = 0;
        if (rates.length) {
          price = parseFloat(rates[0].price);
          for (var i = 1; i < rates.length; i++) {
            var p = parseFloat(rates[i].price);
            if (p < price) { price = p; }
          }
        }
        if (isNaN(price)) { price = 0; }
        shipCache[key] = price;
        if (panel.contains(el)) { apply(price); }
      })
      .catch(function () {});
  }

  /* ---------- Countdown (Black-Friday-Option) --------------------- */
  function clearTimers() {
    Object.keys(timers).forEach(function (id) { clearInterval(timers[id]); });
    timers = {};
  }
  function initTimers() {
    var els = panel.querySelectorAll('[data-epi-timer]');
    Array.prototype.forEach.call(els, function (t) {
      var id = t.getAttribute('data-epi-timer');
      var mins = parseInt(t.getAttribute('data-minutes'), 10) || 3;
      var key = 'epiCartTimer_' + id;
      var end = NaN;
      try { end = parseInt(sessionStorage.getItem(key), 10); } catch (e) {}
      if (!end || isNaN(end)) {
        end = Date.now() + mins * 60000;
        try { sessionStorage.setItem(key, String(end)); } catch (e) {}
      }
      var val = t.querySelector('[data-epi-timer-value]');
      var widget = panel.querySelector('[data-epi-timer-widget="' + id + '"]');
      var tick = function () {
        var left = Math.max(0, Math.round((end - Date.now()) / 1000));
        if (val) { val.textContent = Math.floor(left / 60) + ':' + ('0' + (left % 60)).slice(-2); }
        if (left <= 0) {
          if (widget) { widget.hidden = true; }
          if (timers[id]) { clearInterval(timers[id]); delete timers[id]; }
          return false;
        }
        return true;
      };
      if (tick()) { timers[id] = setInterval(tick, 1000); }  /* abgelaufen → gar kein Intervall starten */
    });
  }

  /* ---------- Karten-Slider: Maus-Drag wie Rebuy/Splide ----------- */
  /* Auf Touch scrollt der Browser nativ (overflow-x). Mit der Maus wäre die zweite Karte
     sonst nur per Shift+Mausrad oder Tab erreichbar (Scrollbar ist ausgeblendet). */
  var drag = null;
  var suppressClick = false;
  function markSliders() {
    Array.prototype.forEach.call(panel.querySelectorAll('.epi-cart__cards'), function (c) {
      c.classList.toggle('is-scrollable', c.scrollWidth > c.clientWidth + 1);
    });
  }
  function onPointerDown(e) {
    if (e.pointerType !== 'mouse' || e.button !== 0 || busy) { return; }
    var cards = e.target && e.target.closest ? e.target.closest('.epi-cart__cards') : null;
    if (!cards || cards.scrollWidth <= cards.clientWidth + 1) { return; }
    drag = { el: cards, x: e.clientX, left: cards.scrollLeft, id: e.pointerId, moved: false };
  }
  /* move/up/cancel hängen am document statt an setPointerCapture: Firefox setzt bei Mousedown auf
     einem <button> ein eigenes natives Capturing – ein zusätzliches setPointerCapture verschluckte
     dort das pointerup, der Drag blieb hängen und alle folgenden Klicks landeten auf dem Slider. */
  function onPointerMove(e) {
    if (!drag || e.pointerId !== drag.id) { return; }
    if (!panel.contains(drag.el)) { drag = null; return; }  /* Slider wurde zwischenzeitlich neu gerendert */
    if (e.buttons === 0) { onPointerEnd(e); return; }  /* Taste wurde außerhalb losgelassen (kein pointerup gesehen) */
    var dx = e.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 4) { return; }
      drag.moved = true;
      drag.el.classList.add('is-dragging');
    }
    drag.el.scrollLeft = drag.left - dx;
    e.preventDefault();
  }
  function onPointerEnd(e) {
    if (!drag || (e && e.pointerId !== undefined && e.pointerId !== drag.id)) { return; }
    var d = drag;
    drag = null;
    if (!d.moved) { return; }
    suppressClick = true;  /* der Klick nach einem Drag darf keine Karte in den Warenkorb legen */
    setTimeout(function () { suppressClick = false; }, 0);
    /* auf die nächste Karte einrasten (Splide-Verhalten), dann Snap-CSS wieder aktivieren */
    var el = d.el, nearest = null, best = Infinity;
    Array.prototype.forEach.call(el.children, function (card) {
      var dist = Math.abs(card.offsetLeft - el.scrollLeft);
      if (dist < best) { best = dist; nearest = card; }
    });
    var target = nearest ? Math.min(nearest.offsetLeft, el.scrollWidth - el.clientWidth) : el.scrollLeft;
    var reduced = false;
    try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (err) {}
    try { el.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' }); } catch (err) { el.scrollLeft = target; }
    setTimeout(function () { el.classList.remove('is-dragging'); }, 400);
  }

  /* ---------- Aktionen im Flyout --------------------------------- */
  function onPanelClick(e) {
    if (suppressClick) { e.preventDefault(); e.stopPropagation(); return; }
    var t = e.target.closest('[data-epi-close],[data-epi-qty],[data-epi-remove],[data-epi-upgrade],[data-epi-add]');
    if (!t) { return; }
    if (t.hasAttribute('data-epi-close')) { e.preventDefault(); close(); return; }
    /* Safari feuert click auch auf das SVG-Kind eines deaktivierten Buttons */
    if (busy || t.disabled) { e.preventDefault(); return; }

    if (t.hasAttribute('data-epi-qty')) { e.preventDefault(); stepQty(t); return; }

    var job = null, note = '';
    if (t.hasAttribute('data-epi-remove')) {
      var rkey = t.getAttribute('data-epi-remove');
      clearTimeout(pendingTimers[rkey]); delete pendingTimers[rkey]; delete pending[rkey];  /* offene Mengenänderung der Zeile ist hinfällig */
      note = 'Artikel entfernt';
      job = function () { return post(cartUrl + '/change.js', { id: rkey, quantity: 0 }); };
    } else if (t.hasAttribute('data-epi-upgrade')) {
      var ukey = t.getAttribute('data-epi-upgrade');
      var props = {};
      try { props = JSON.parse(t.getAttribute('data-props') || '{}'); } catch (err) { props = {}; }
      /* Liquid gibt leere Properties als [] aus – Shopify verlangt ein Objekt */
      if (Object.prototype.toString.call(props) !== '[object Object]') { props = {}; }
      props._epi_cart = 'abo-upgrade';
      var uqty = parseInt(t.getAttribute('data-qty'), 10) || 1;
      if (pending[ukey]) { uqty = pending[ukey].qty || uqty; clearTimeout(pendingTimers[ukey]); delete pendingTimers[ukey]; delete pending[ukey]; }
      var plan = parseInt(t.getAttribute('data-plan'), 10);
      track('upgrade_click', t.getAttribute('data-label'));
      note = 'Abo-Upgrade übernommen';
      /* Liquid lässt versteckte (_-)Properties weg – Zeile frisch aus /cart.js lesen, alle Properties übernehmen */
      job = function () {
        return fetchJSON(cartUrl + '.js', { credentials: 'same-origin' }).then(function (cart) {
          var merged = {}, src = props, line = null;
          for (var li = 0; li < cart.items.length; li++) { if (cart.items[li].key === ukey) { line = cart.items[li]; break; } }
          if (line && Object.prototype.toString.call(line.properties) === '[object Object]') { src = line.properties; }
          for (var pk in src) { if (Object.prototype.hasOwnProperty.call(src, pk)) { merged[pk] = src[pk]; } }
          merged._epi_cart = 'abo-upgrade';
          return post(cartUrl + '/change.js', { id: ukey, quantity: uqty, selling_plan: plan, properties: merged });
        });
      };
    } else if (t.hasAttribute('data-epi-add')) {
      var source = t.getAttribute('data-source') || 'cross-sell';
      var vid = parseInt(t.getAttribute('data-epi-add'), 10);
      track(source + '_add', t.getAttribute('data-label'));
      note = 'Produkt hinzugefügt';
      job = function () { return post(cartUrl + '/add.js', { items: [{ id: vid, quantity: 1, properties: { _epi_cart: source } }] }); };
    }
    if (!job) { return; }

    e.preventDefault();
    flushPending();  /* noch nicht gesendete Mengen zuerst, damit Server und Anzeige übereinstimmen */
    pendingFocus = focusSelector(t);  /* vor dem Deaktivieren merken, sonst springt der Fokus auf body */
    t.disabled = true;
    enqueue(job, note);
  }
  /* „Zur Kasse“ während eine Menge noch nicht gesendet ist (Tipp auf „+“ und sofort zur Kasse):
     erst die Schlange abarbeiten, dann das (neu gerenderte) Formular abschicken – sonst landet die
     alte Menge im Checkout. */
  function onPanelSubmit(e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('epi-cart__checkout-form')) { return; }
    if (!busy && !hasPending()) { return; }
    e.preventDefault();
    root.classList.add('is-loading');
    var errorsBefore = errorCount;
    flushPending();
    whenIdle().then(function () {
      var f = panel.querySelector('.epi-cart__checkout-form');
      /* Warenkorb inzwischen leer oder eine Änderung ist fehlgeschlagen: nicht blind zur Kasse,
         die Fehlermeldung bleibt sichtbar */
      if (!isOpen || !f || errorCount !== errorsBefore) { root.classList.remove('is-loading'); return; }
      root.classList.add('is-loading');
      /* der Name des Submit-Buttons (checkout) geht bei form.submit() verloren – als Feld nachziehen */
      var hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'checkout'; hidden.value = '';
      f.appendChild(hidden);
      f.submit();
    });
  }

  /* Listener am Section-Markup – wird im Theme-Editor nach jedem Section-Reload neu gebunden */
  function bindRoot(el) {
    root = el;
    panel = root.querySelector('[data-epi-cart-panel]');
    errors = root.querySelector('[data-epi-errors]');
    errors.setAttribute('role', 'alert');
    status = root.querySelector('[data-epi-status]');
    root.querySelector('.epi-cart__underlay').addEventListener('click', close);
    panel.addEventListener('click', onPanelClick);
    panel.addEventListener('submit', onPanelSubmit);
    panel.addEventListener('pointerdown', onPointerDown);
    panel.addEventListener('dragstart', function (e) { if (drag) { e.preventDefault(); } });  /* kein Bild-Geist beim Ziehen (Firefox) */
  }
  bindRoot(root);
  document.addEventListener('pointermove', onPointerMove);
  document.addEventListener('pointerup', onPointerEnd);
  document.addEventListener('pointercancel', onPointerEnd);
  window.addEventListener('blur', function () { if (drag) { onPointerEnd(null); } });  /* Maus außerhalb des Fensters losgelassen */

  function isVisible(el) { return el.getClientRects().length > 0; }
  document.addEventListener('keydown', function (e) {
    if (!isOpen) { return; }
    if (e.key === 'Escape' || e.key === 'Esc') { close(); return; }
    if (e.key === 'Tab') {
      var focusable = Array.prototype.filter.call(
        root.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        isVisible  /* ausgeblendete Widgets (abgelaufener Countdown) dürfen die Falle nicht durchlöchern */
      );
      if (!focusable.length) { return; }
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Anbindung ans Theme --------------------------------- */
  /* Nach jedem Add-to-Cart des Themes (statt Popdown) */
  document.addEventListener('theme:cart:popdown', function () { open(); });

  /* Fremde Änderungen (Seal, Apps, /cart-Seite) bei offenem Flyout nachziehen.
     Nach einem Add-to-Cart feuert das Theme dieses Event kurz nach dem Popdown mit dem
     vollen Warenkorb – zeigt der laufende/letzte Render bereits denselben Stand
     (Anzahl + Summe), entfällt der zweite Section-Fetch. */
  var changeTimer = null;
  function rendersState(cart) {
    if (!looksLikeCart(cart)) { return false; }
    var state = panel.querySelector('[data-epi-cart-state]');
    if (!state) { return false; }
    if (parseInt(state.getAttribute('data-count'), 10) !== cart.item_count ||
        parseInt(state.getAttribute('data-total'), 10) !== cart.total_price) { return false; }
    /* Gleiche Anzahl und Summe reichen nicht: ein Abo-Tausch zum selben Preis (Seal), ein
       Zusammenlegen zweier Zeilen oder geänderte Eigenschaften ändern nur die Positions-Keys. */
    if (!Array.isArray(cart.items)) { return false; }
    var rendered = Array.prototype.map.call(panel.querySelectorAll('[data-epi-item]'), function (li) { return li.getAttribute('data-epi-item') || ''; });
    var incoming = cart.items.map(function (it) { return (it && it.key) ? String(it.key) : ''; });
    if (rendered.length !== incoming.length) { return false; }
    return rendered.sort().join('\n') === incoming.sort().join('\n');
  }
  document.addEventListener('theme:cart:change', function (e) {
    if (internalChange || !isOpen || busy) { return; }
    var cart = e.detail && e.detail.cart;
    clearTimeout(changeTimer);
    changeTimer = setTimeout(function () {
      (inflight || Promise.resolve()).then(function () {
        if (!isOpen || busy || rendersState(cart)) { return; }
        refresh();
      });
    }, 150);
  });

  /* Warenkorb-Icon im Header öffnet das Flyout (Capture, vor Theme-Handlern) */
  var pathNow = window.location.pathname.replace(/\/$/, '');
  var onCartPage = pathNow === cartUrl || pathNow.slice(-5) === '/cart';
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-drawer-toggle="drawer-cart"]');
    if (!a || onCartPage) { return; }
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);

  /* Öffnen per Custom-Event (z. B. aus anderen Skripten) */
  document.addEventListener('epi-cart:open', function () { open(); });
  document.addEventListener('epi-cart:close', function () { close(); });

  /* Theme-Editor: Section wird bei jeder Einstellungsänderung neu gerendert */
  if (window.Shopify && window.Shopify.designMode) {
    var rebind = function (e) {
      if (!e.detail || e.detail.sectionId !== sectionId) { return; }
      var fresh = document.querySelector('[data-epi-cart]');
      if (fresh && fresh !== root) {
        clearTimers();
        drag = null;
        bindRoot(fresh);
        isOpen = false;
      }
      open();
    };
    document.addEventListener('shopify:section:load', rebind);
    document.addEventListener('shopify:section:select', rebind);
    document.addEventListener('shopify:block:select', function (e) { if (e.detail && e.detail.sectionId === sectionId) { open(); } });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === sectionId) { close(); } });
  }
})();
